import { Caption } from '@remotion/captions';
import { filterCurrentlyDisplayedLines } from './helpers/get-number-of-lines-for-text';
import { StaticWord } from './StaticWord';

export function StaticLines({
  lines,
  frame,
  transcriptionColor,
}: {
  lines: Caption[][];
  frame: number;
  transcriptionColor: string;
}) {
  const currentlyShownLines = filterCurrentlyDisplayedLines({
    lines,
    frame,
  });

  return (
    <div>
      {currentlyShownLines.map((line: Caption[]) => (
        <div key={line.map((item: Caption) => item.text).join(' ')}>
          {line.map((item: Caption) => (
            <span key={item.startMs + item.endMs} id={String(item.startMs + item.endMs)}>
              <StaticWord frame={frame} item={item} transcriptionColor={transcriptionColor} />
            </span>
          ))}
        </div>
      ))}
    </div>
  );
}
